var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.checkValidVersion('4.4.0'))?_c('Login_4_4',{attrs:{"login":_vm.login,"from":_vm.from,"auth_uuid":_vm.auth_uuid}}):_vm._e(),(!_vm.checkValidVersion('4.4.0'))?_c('Login',{attrs:{"login":_vm.login,"from":_vm.from,"auth_uuid":_vm.auth_uuid}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }